module.exports = __webpack_public_path__ + "static/img/wasteR.a6e66161.png";